import { FullStory, init } from "@fullstory/browser";
import * as Sentry from "@sentry/vue";

import config from "@/config";

import {
  AnalyticsProviderApiKeyMissingError,
  AnalyticsProviderInitializationError,
} from "../exceptions";

import type { AnalyticsEvent } from "@/enums/analytics";
import type { AnalyticsProvider } from "@/lib/analytics/analytics";

export class FullStoryAnalyticsProvider implements AnalyticsProvider {
  init() {
    const orgId = config.fsOrgId;

    if (!orgId?.length) {
      // eslint-disable-next-line no-console
      console.error(new AnalyticsProviderApiKeyMissingError(FullStoryAnalyticsProvider.name));
      return false;
    }

    try {
      init({
        orgId,
        recordCrossDomainIFrames: true,
        devMode: false,
      });
      return true;
    } catch (error) {
      Sentry.captureException(
        new AnalyticsProviderInitializationError(FullStoryAnalyticsProvider.name, error as Error)
      );
      return false;
    }
  }

  trackEvent(eventName: AnalyticsEvent, properties?: Record<string, unknown>) {
    const defaultProperties = { environment: import.meta.env.MODE };
    FullStory("trackEvent", {
      name: eventName,
      properties: { ...defaultProperties, ...properties },
    });
  }

  onUserChange<TUserData extends { id: string | number }>(userData: TUserData | null) {
    const identityPayload = userData?.id
      ? { uid: String(userData.id), properties: userData }
      : { anonymous: true };

    FullStory("restart");
    FullStory("setIdentity", identityPayload);
  }

  onUserPropertiesChange<TData extends Record<string, unknown>>(properties: TData) {
    FullStory("setProperties", { type: "user", properties });
  }
}
